import { render, staticRenderFns } from "./ProductPriceAreaApp.vue?vue&type=template&id=f35446fc&scoped=true"
import script from "./ProductPriceAreaApp.vue?vue&type=script&lang=js"
export * from "./ProductPriceAreaApp.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceAreaApp.vue?vue&type=style&index=0&id=f35446fc&prod&lang=less&scoped=true"
import style1 from "./ProductPriceAreaApp.vue?vue&type=style&index=1&id=f35446fc&prod&scoped=true&lang=css"
import style2 from "./ProductPriceAreaApp.vue?vue&type=style&index=2&id=f35446fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35446fc",
  null
  
)

export default component.exports